import type { Layer, LayerID } from "@pdfking/renderer-api"
import type { PrimaryKey } from "@pdfking/templates"
import { RecordByPrimaryKey } from "@pdfking/templates"

import { OwnName } from "../utils/OwnName"

/** Our layer ids — `layer_list` in `objects/layer/library.py`, marked as ours. */
export const CROSSMARK_LAYER_ID = OwnName<LayerID>("crossmark")
export const FILE_LAYER_ID = OwnName<LayerID>("file")
export const MARKING_LAYER_ID = OwnName<LayerID>("marking")
export const PAGE_MARKING_LAYER_ID = OwnName<LayerID>("page_marking")
export const HELP_LAYER_ID = OwnName<LayerID>("help")
export const NAME_LAYER_ID = OwnName<LayerID>("name")
export const FOLD_LAYER_ID = OwnName<LayerID>("fold")
export const CUT_LAYER_ID = OwnName<LayerID>("cut")

type LayerDef = PrimaryKey<LayerID> & Layer

/** Layer defs keyed by id, bottom to top — Python `layer_list.objects`, but
 * with the crossmarks over the files. */
export const LayerList = RecordByPrimaryKey<LayerDef>([
  {
    id: FILE_LAYER_ID,
    visible: true,
    printable: true,
    locked: false,
    idml_color: "Blue",
  },
  // Over the files, so its paper hides their bleed; under the colorbar.
  {
    id: CROSSMARK_LAYER_ID,
    visible: true,
    printable: true,
    locked: false,
    idml_color: "Black",
  },
  {
    id: MARKING_LAYER_ID,
    visible: true,
    printable: true,
    locked: false,
    idml_color: "Purple",
  },
  {
    id: PAGE_MARKING_LAYER_ID,
    visible: true,
    printable: true,
    locked: false,
    idml_color: "Purple",
    idml_merge_with: MARKING_LAYER_ID,
  },
  {
    id: HELP_LAYER_ID,
    visible: true,
    printable: false,
    locked: false,
    idml_color: "Gray",
  },
  {
    id: NAME_LAYER_ID,
    visible: true,
    printable: false,
    locked: false,
    idml_color: "Cyan",
  },
  {
    id: FOLD_LAYER_ID,
    visible: true,
    printable: false,
    locked: false,
    idml_color: "Green",
  },
  {
    id: CUT_LAYER_ID,
    visible: true,
    printable: false,
    locked: false,
    idml_color: "Red",
  },
])
